import { Component, OnInit } from '@angular/core';
import { AnalyticEvent } from 'app/lib/analytic-event';
import { LogService } from 'app/lib/log.service';
import { UserService } from '../../../lib/user.service';
import { User } from '../../../models/user';
import { TOOLS_CONFIG } from '../../../lib/constants';
import { ApiService } from 'app/lib/api.service';

@Component({
    selector: 'app-practice',
    templateUrl: './practice.component.html',
    styleUrls: ['./practice.component.scss'],
})
export class PracticeComponent implements OnInit {
    user: User;
    hideNotes: boolean = false;
    defaultTools = TOOLS_CONFIG.TOOLS_LIST_LANG;
    toolsConfig = [];
    thoughtsTools = [];
    actionsTools = [];
    zenroom = [];
    showThoughts: boolean = true;
    showActions: boolean = true;
    isLoaded: boolean = false;
    constructor(
        private userService: UserService,
        private log: LogService,
        private apiService: ApiService
    ) {
        this.log.event(AnalyticEvent.event.practiceLoaded);
    }

    ngOnInit() {
        this.user = this.userService.getUser();
        if (
            this.user.primaryOrganization &&
            this.user.primaryOrganization.settings &&
            this.user.primaryOrganization.settings.hideNotes !== null
        ) {
            this.hideNotes = this.user.primaryOrganization.settings.hideNotes;
        }
        this.setToolsConfig();
    }

    setToolsConfig() {
        if (this.user.primaryOrganization && this.user.primaryOrganization.id) {
            this.isLoaded = true;
            this.toolsConfig = this.user.primaryOrganization.toolsConfig;
        } else {
            this.getDefaultToolsList();
        }
    }

    getDefaultToolsList() {
        this.isLoaded = false;
        let toolsList = [];
        this.apiService.get('tools/default').subscribe(
            (result: any) => {
                if (result) {
                    result?.forEach((tool: any) => {
                        toolsList.push({
                            id: tool.ID,
                            toolID: tool.ID,
                            name: tool.Title,
                            enabled: tool.Default,
                            default: tool.Default,
                            key: tool.ToolKey,
                        });
                    });
                    this.toolsConfig = toolsList;
                    this.isLoaded = true;
                }
            },
            (error: any) => {
                this.isLoaded = true;
                this.log.error(
                    'Error getting tools default list. ' + error.message
                );
            }
        );
    }
    isToolEnable(key: string) {
        const tool = this.toolsConfig.find(item => item.key === key);
        this.toolsConfig.forEach(tool => {
            if (this.defaultTools[tool.key]?.toolGroup === 'thoughts') {
                if (
                    !this.thoughtsTools.includes(this.defaultTools[tool.key]) &&
                    tool.enabled
                ) {
                    this.defaultTools[tool.key].enabled = tool.enabled;
                    this.thoughtsTools.push(this.defaultTools[tool.key]);
                }
            } else if (
                this.defaultTools[tool.key]?.toolGroup === 'actions' &&
                tool.enabled
            ) {
                if (!this.actionsTools.includes(this.defaultTools[tool.key])) {
                    this.defaultTools[tool.key].enabled = tool.enabled;
                    this.actionsTools.push(this.defaultTools[tool.key]);
                }
            } else {
                if (
                    !this.zenroom.includes(this.defaultTools[tool.key]) &&
                    tool.enabled
                ) {
                    this.defaultTools[tool.key].enabled = tool.enabled;
                    this.zenroom.push(this.defaultTools[tool.key]);
                }
            }
        });

        if (this.actionsTools.length == 0) {
            this.showActions = false;
        } else if (this.thoughtsTools.length == 0) {
            this.showThoughts = false;
        }
        return tool.enabled ? true : false;
    }
}
